import { blockHomeHeading } from "./block-home-heading";
import { blockTextMedia } from "./block-text-media";
import { blockRealisationsSlider } from "./block-realisations-slider";
import { blockPartnersSlider } from "./block-partners-slider";
import { blockGallerySlider } from "./block-gallery-slider";
import { menu } from "./menu";
import { animation } from "./animation";
import { chiffre } from "./chiffre";

/** Init */
$(function () {
  menu();
  chiffre();
  blockHomeHeading();
  blockTextMedia();
  blockRealisationsSlider();
  blockPartnersSlider();
  blockGallerySlider();
  animation();
});
